const WaveDividerDemo = () => {
  return (
    <div className="min-h-screen bg-background p-8">
      <h1 className="text-4xl font-bold text-center mb-12">Wave Divider Options</h1>
      
      <div className="space-y-16">
        {/* Option 1 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">1. Gentle Single Wave</h2>
          <div className="relative h-64 bg-[#2C003E]">
            <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
              <svg 
                className="relative block w-full h-24" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 1200 120" 
                preserveAspectRatio="none"
              >
                <path d="M0,0 L0,50 Q300,100 600,50 T1200,50 L1200,0 Z" fill="#C5E063"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Option 2 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">2. Double Wave (Current)</h2>
          <div className="relative h-64 bg-[#2C003E]">
            <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
              <svg 
                className="relative block w-full h-24" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 1200 120" 
                preserveAspectRatio="none"
              >
                <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#C5E063"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Option 3 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">3. Smooth Sine Wave</h2>
          <div className="relative h-64 bg-[#2C003E]">
            <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
              <svg 
                className="relative block w-full h-24" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 1200 120" 
                preserveAspectRatio="none"
              >
                <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" fill="#C5E063"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Option 4 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">4. Dramatic Curve</h2>
          <div className="relative h-64 bg-[#2C003E]">
            <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
              <svg 
                className="relative block w-full h-24" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 1200 120" 
                preserveAspectRatio="none"
              >
                <path d="M0,0 C200,100 400,100 600,50 C800,0 1000,0 1200,50 L1200,0 Z" fill="#C5E063"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Option 5 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">5. Subtle Tilt</h2>
          <div className="relative h-64 bg-[#2C003E]">
            <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
              <svg 
                className="relative block w-full h-24" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 1200 120" 
                preserveAspectRatio="none"
              >
                <path d="M0,0 L0,80 Q600,20 1200,80 L1200,0 Z" fill="#C5E063"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Option 6 - Clip Path */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">6. Zigzag Wave (Clip-Path)</h2>
          <div className="relative h-64 bg-[#2C003E]">
            <div 
              className="absolute top-0 left-0 w-full h-[120px] bg-[#C5E063]"
              style={{
                clipPath: 'polygon(0% 100%, 10% 80%, 20% 100%, 30% 80%, 40% 100%, 50% 80%, 60% 100%, 70% 80%, 80% 100%, 90% 80%, 100% 100%, 100% 0%, 0% 0%)'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaveDividerDemo;
